module.exports = __webpack_public_path__ + "img/search-icon.e0fb1d64.svg";